import React from 'react';
import { IconButton } from '@mui/material';
import { Instagram, LinkedIn, Reddit, X as XIcon } from '@mui/icons-material';

const SocialIcons = () => {
    return (
        <div>
            <IconButton href="https://www.instagram.com/marketrodeo" target="_blank" color="inherit">
                <Instagram />
            </IconButton>
            <IconButton href="https://www.linkedin.com/company/marketrodeo" target="_blank" color="inherit">
                <LinkedIn />
            </IconButton>
            <IconButton href="https://www.reddit.com/r/marketrodeo" target="_blank" color="inherit">
                <Reddit />
            </IconButton>
            <IconButton href="https://x.com/Market_Rodeo" target="_blank" color="inherit">
                <XIcon />
            </IconButton>
        </div>
    );
};

export default SocialIcons;